import styled from "styled-components";
import { useLogEvent } from "../hooks/useLogEvent";
import { colors, device } from "../styles/stylesConfig";
import { ProductProps } from "../interfaces/TextsInterfaces";
import { ProductsListView } from "./ProductsListView";
import { useTranslation } from "react-i18next";

const ContentContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-self: center;
    z-index: 2;
    position: relative;
    padding: 5vh 0;
    background-color: ${colors.dark};
`

const Target = styled.div`
    height: 1px;
    width: 1px;
    position: absolute;
    top: -12vh;
`

const Title = styled.h2`
    width: 100%;
    font-weight: 700;
    font-size: 38px;
    color: ${colors.primary};
    letter-spacing: 5px;
    line-height: 60px;
    margin-bottom: 30px;
    text-transform: uppercase;
    transition: all 0.3s ease-in-out;
    position: relative;
    text-align: center;


    @media ${device.lg} {
        font-size: 32px;
    }

    @media ${device.md} {
        font-size: 28px;
        text-align: center;
        margin-bottom: 20px;
    }   

    @media ${device.sm} {
        font-size: 20px;
        line-height: 30px;
    }
`

interface Props {
    setShowModal: React.Dispatch<React.SetStateAction<ProductProps | null>>
}

export const Catalog = ({ setShowModal }: Props) => {

    const { handleLogEvent } = useLogEvent();
    const { t } = useTranslation();
    const data: any = t('products.data', { returnObjects: true });

    return (

        <ContentContainer>

            <Target id="products" />

            <Title className="utils__fade-in-fast-top"> {t('products.title')}</Title>

            <ProductsListView
                data={data}
                onClickProduct={(product: ProductProps) => {

                    // setShowModal(product);

                    let message = t('wsp.link.number') + t('wsp.link.message.product', { p: product.title.toUpperCase() });

                    handleLogEvent('click_' + product.title.toLowerCase().replace(/ /g, "_"));

                    window.open(message, 'blank')

                }}

            />

        </ContentContainer>

    )
}
